import * as _createNumberMask from 'text-mask-addons/dist/createNumberMask';

const VALIDATION_ERROR_FLASH_MESSAGE = $localize`Please fill in the missing information to save these settings`;

const MESSAGE_MEDIUM_DURATION_MS = 5000;

export { VALIDATION_ERROR_FLASH_MESSAGE, MESSAGE_MEDIUM_DURATION_MS };

export interface INumberInputMask {
  prefix: string;
  suffix: string;
  allowDecimal: boolean;
  integerLimit: number;
  decimalLimit: number;
  allowNegative: boolean;
  includeThousandsSeparator: boolean;
}

export function createNumberMask(
  integerLimit: number,
  decimalLimit: number,
  prefix: string = '',
  suffix: string = '',
): INumberInputMask {
  const { default: _createNumberMaskFun } = _createNumberMask;
  return _createNumberMaskFun({
    prefix,
    suffix,
    allowDecimal: !!decimalLimit,
    integerLimit,
    decimalLimit,
  });
}

export function createDecimalInputMask(decimalPoints: number): INumberInputMask {
  const { default: _createNumberMaskFun } = _createNumberMask;
  return _createNumberMaskFun({
    prefix: '',
    allowDecimal: decimalPoints,
    decimalLimit: decimalPoints,
    thousandsSeparatorSymbol: '',
  });
}

export function createNumbersWithNegativeMask(
  integerLimit: number,
  decimalLimit: number,
  prefix: string = '',
  suffix: string = '',
  allowNegative: boolean = false,
): INumberInputMask {
  const { default: _createNumberMaskFun } = _createNumberMask;
  return _createNumberMaskFun({
    prefix,
    suffix,
    allowDecimal: !!decimalLimit,
    integerLimit,
    decimalLimit,
    allowNegative,
  });
}
